export default "__VITE_ASSET__D1UPDCCL__"